export const types = {
    setImagenesPreloader:"setImagenesPreloader",
    setVideosPreloader:"setVideosPreloader",
    setActiveCarga:"setActiveCarga",
    setTipoIdioma:"setTipoIdioma"
}
